module.exports = __webpack_public_path__ + "static/media/user_outline_front.1af43657.png";